import React from 'react';
import SatSelect from '@components/common/satUI/SatSelect';
import SatValidationErrMsg from '@components/common/satUI/SatValidationErrMsg';
import { isEmptyString } from '@common/utils';

const InputPayinPeriod = ({ isErrorVisible, value, onChange }) => {
  return (
    <>
      <SatSelect
        title={'보험료 납입주기'}
        value={value}
        options={[
          { label: '월납', value: '월납' },
          { label: '2개월납', value: '2개월납' },
          { label: '3개월납', value: '3개월납' },
          { label: '6개월납', value: '6개월납' },
          { label: '연납', value: '연납' },
          { label: '일시납', value: '일시납' },
        ]}
        onChange={option => onChange(option.value)}
      />

      <SatValidationErrMsg
        type="error"
        visible={isErrorVisible && isEmptyString(value)}
        message="값을 입력해주세요."
      />
    </>
  );
};

export default InputPayinPeriod;
